module.exports = __webpack_public_path__ + "static/media/markIcon.0bbce60e.svg";